import * as React from 'react';
import { WebPage } from '@grandvisionhq/analytics';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';

const WebPageSchema = ()=>{
    const { activeVariant: { description  } , product: { brandName  } , productUrl ,  } = useProductData();
    return /*#__PURE__*/ React.createElement(WebPage, {
        url: productUrl,
        pageType: "ProductDetail",
        name: brandName,
        description: description
    });
};

export { WebPageSchema };
//# sourceMappingURL=WebPageSchema.js.map
